import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Brain, ArrowLeft } from "lucide-react";

export default function StaffAuth() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const submit = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      login(data.token, data.user);
      toast.success("Bienvenido");
      navigate(data.user.role === "admin" ? "/admin" : "/supervisor");
    } catch (e) {
      toast.error(formatError(e.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-6">
      <div className="w-full max-w-md sepp-fade">
        <button onClick={() => navigate("/")} className="mb-8 flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground" data-testid="back-home">
          <ArrowLeft className="h-4 w-4" /> Volver
        </button>
        <div className="rounded-2xl border border-border bg-card p-8 shadow-sm">
          <div className="mb-6 flex h-11 w-11 items-center justify-center rounded-lg bg-primary text-primary-foreground">
            <Brain className="h-5 w-5" />
          </div>
          <h1 className="font-display text-2xl font-bold">Acceso staff</h1>
          <p className="mt-1 text-sm text-muted-foreground">Supervisores y administradores.</p>
          <div className="mt-6 space-y-4">
            <div className="space-y-2">
              <Label htmlFor="email">Correo</Label>
              <Input id="email" type="email" data-testid="staff-email-input" value={email}
                onChange={(e) => setEmail(e.target.value)} placeholder="admin@centrodepsicoterapiacognitiva.com" />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">Contraseña</Label>
              <Input id="password" type="password" data-testid="staff-password-input" value={password}
                onChange={(e) => setPassword(e.target.value)} onKeyDown={(e) => e.key === "Enter" && submit()} />
            </div>
            <Button className="w-full" disabled={busy || !email || !password} onClick={submit} data-testid="staff-login-button">
              {busy ? "Ingresando..." : "Ingresar"}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
